export const RouteNames = {
  BLOG_HOME: "blog_home",
  BLOG_CATEGORY: "blog_category",
  BLOG_TAG: "blog_tag",
  BLOG_POST: "blog_post",
};
